<a (click)="navigateToUrl()" class="pointer">
  <div *ngIf="data?.cells['Tag']?.value" class="tag" matTooltip="{{tagTooltip}}">
    {{tag}}
  </div>
  <div class="card-title" matTooltip="{{data?.cells['DisplayName'].value}}">
    {{data.cells['DisplayName'].value}}
  </div>
</a>
